import { DEFAULTS } from "./defaults";
import { INDENT_TYPE } from "./types";
const pluginIndent = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: INDENT_TYPE
  };
};
export {
  pluginIndent
};
//# sourceMappingURL=viewer.js.map
